export const SMALL_TAB_BAR_SIZE = 72;
export const MEDIUM_WEB_TAB_BAR_SIZE = 275;
export const BIG_WEB_TAB_BAR_SIZE = 775;
